import { render, staticRenderFns } from "./DefaultLanguage.vue?vue&type=template&id=d1a0cc3c&scoped=true"
import script from "./DefaultLanguage.vue?vue&type=script&lang=js"
export * from "./DefaultLanguage.vue?vue&type=script&lang=js"
import style0 from "./DefaultLanguage.vue?vue&type=style&index=0&id=d1a0cc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a0cc3c",
  null
  
)

export default component.exports